export default __webpack_public_path__ + "static/media/icon-team.a6cb752d.svg";